export default "__VITE_ASSET__mm2zsM1m__"